<template>
	<section :class="['block-wrapper', componentClass, colorMode, styleClasses, { visible: visible, ready: ready } ]">
		<div class="row">
			<div class="dc-timeline columns small-12">
				<div v-for="(category, catindex) in data.category" :key="'category-' + catindex" class="items-group">
					<div class="category-title">
						<h2 v-html="sanitize(category.title)"></h2>
					</div>
					<div v-for="(item, index) in category.items" :key="'item-' + index" :class="['row item', 'align-'+item.alignment_class]">
						<div class="item-content columns small-10 small-offset-2 medium-5 medium-offset-0">
							<div class="line" :class="item.alignment_class"><span></span></div>
							<media-content 
								ref="mediaWrapper" 
								:data="item.media_content" 
								:ready="ready" 
								:height="'auto'"></media-content>		
							<h3 class="title" v-html="sanitize(item.title)"></h3>
							<div class="text" v-html="sanitize(item.text)"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import BaseBlock from './Base'
import MediaContent from './media/Content'
import DOMPurify from 'dompurify';

export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'timeline-wrapper',
			mediaWrapperHeight: 0,
			animated: false,
		}
	},
	methods: {
		handleMediaHeightChange() {
			this.centerTextIfNeeded()
		},
		centerTextIfNeeded() {
			if (this.data.component_id==="component-2") return;
			if (window.innerWidth<=this.mobileBreakpoint) {
				this.mediaWrapperHeight = 0;
				this.verticallyCenterText = false;
			} else {
				if (typeof this.$el === 'undefined' || typeof this.$refs.mediaWrapper === 'undefined' || typeof this.$refs.textWrapper === 'undefined') {
					setTimeout(() => { this.centerTextIfNeeded() }, 750);
					return;
				}
				this.mediaWrapperHeight = this.$refs.mediaWrapper.$el.clientHeight;
				var textWrapperHeight = this.$refs.textWrapper.$el.clientHeight;
				this.verticallyCenterText = (this.mediaWrapperHeight>textWrapperHeight);
			}
		},
		sanitize(text) {
			return DOMPurify.sanitize(text);
		}
	},
	computed: {
		styleClasses() {
			return this.data.styles || ''
		}
	},
	components: {
		MediaContent
	}
}
</script>

<style lang="scss">
		@import "../../styles/scss/component/timeline";
</style>